import { ActionType, ComponentType } from '../../enums';

export interface CreateCtaClickEventPayloadOptions {
  componentType?: ComponentType;
  componentVariant?: string;
  itemText: string;
  itemType: string;
  pageType?: string;
  url: string;
}

export interface CreateCtaClickEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    component_variant?: string;
    item_text: string;
    item_type: string;
    page_type?: string;
    url: string;
  };
}

export const createCtaClickEventPayload = ({
  itemText,
  itemType,
  url,
  pageType,
  componentVariant,
  componentType,
}: CreateCtaClickEventPayloadOptions): CreateCtaClickEventPayloadReturn => {
  const payload: CreateCtaClickEventPayloadReturn = {
    event_data: {
      action: ActionType.CLICK,
      component_type: componentType ?? ComponentType.CTA,
      item_text: itemText,
      item_type: itemType,
      url,
    },
  };

  if (componentVariant !== undefined) {
    payload.event_data.component_variant = componentVariant;
  }
  if (pageType !== undefined) {
    payload.event_data.page_type = pageType;
  }

  return payload;
};
